export const PROVIDER = "provider";
export const PROVIDER_PAYMENT_METHOD = "provider_payment_method";
export const PRACTICE_LICENSES = "practice_licenses";
export const PROVIDER_LICENSES = "licenses";
export const ACTIVE_PATIENTS_LIMIT = "active_patients_limit";
export const REMAINING_CAPACITY = "remaining_capacity";
export const ACCEPT_NEW_PATIENTS = "new_patients";
export const ACTIONS = "actions";
